import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserService } from '../services/user.service';

export const accountGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const userService = inject(UserService);

  const code = await userService.getVerificationCode();

  if (code) {
    await userService.setVerificationCode(null);
    return true;
  }

  router.navigate(['/account/account-view-verification-code']);
  return false;
};
